<p-dialog [(visible)]="visible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{ width: '420px' }"
          [breakpoints]="{ '575px': '95vw' }"
          appendTo="body"
          styleClass="cc-dialog"
          (onHide)="cerrar()">

    <ng-template pTemplate="header">
        <div class="d-flex align-items-center gap-3">
            <div class="cc-dialog-icon">
                <i class="pi pi-lock"></i>
            </div>
            <div>
                <h5 class="mb-0 fw-bold">Cambiar contraseña</h5>
                <p class="mb-0 text-muted small">{{ cuenta }}</p>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        @if (aviso) {
        <div class="alert alert-warning py-2 fs-13 mb-3">
            <i class="ri-lock-password-line me-2"></i>{{ aviso }}
        </div>
        }

        @if (error()) {
        <div class="alert alert-danger py-2 fs-13 mb-3">
            <i class="ri-error-warning-line me-2"></i>{{ error() }}
        </div>
        }

        <div class="d-flex flex-column gap-3">
            <div>
                <label class="cc-label" for="cc-actual">Contraseña actual</label>
                <div class="position-relative">
                    <input id="cc-actual" [type]="verActual() ? 'text' : 'password'" class="form-control pe-5"
                           [(ngModel)]="actual"
                           autocomplete="current-password"
                           placeholder="Contraseña actual">
                    <button type="button" tabindex="-1" aria-label="Mostrar u ocultar la contraseña"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            (click)="verActual.update(v => !v)">
                        <i [class]="verActual() ? 'ri-eye-off-fill' : 'ri-eye-fill'" class="fs-16"></i>
                    </button>
                </div>
            </div>
            <div>
                <label class="cc-label" for="cc-nueva">Nueva contraseña</label>
                <div class="position-relative">
                    <input id="cc-nueva" [type]="verNueva() ? 'text' : 'password'" class="form-control pe-5"
                           [(ngModel)]="nueva"
                           [attr.maxlength]="maximo"
                           [attr.autofocus]="contrasenaActual ? '' : null"
                           autocomplete="new-password"
                           placeholder="Nueva contraseña">
                    <button type="button" tabindex="-1" aria-label="Mostrar u ocultar la contraseña"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            (click)="verNueva.update(v => !v)">
                        <i [class]="verNueva() ? 'ri-eye-off-fill' : 'ri-eye-fill'" class="fs-16"></i>
                    </button>
                </div>
                <small class="text-muted fs-12">Máximo {{ maximo }} caracteres.</small>
            </div>
            <div>
                <label class="cc-label" for="cc-confirmar">Confirmar contraseña</label>
                <div class="position-relative">
                    <input id="cc-confirmar" [type]="verConfirmar() ? 'text' : 'password'" class="form-control pe-5"
                           [(ngModel)]="confirmar"
                           [attr.maxlength]="maximo"
                           autocomplete="new-password"
                           placeholder="Repite la contraseña nueva"
                           (keyup.enter)="guardar()">
                    <button type="button" tabindex="-1" aria-label="Mostrar u ocultar la contraseña"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            (click)="verConfirmar.update(v => !v)">
                        <i [class]="verConfirmar() ? 'ri-eye-off-fill' : 'ri-eye-fill'" class="fs-16"></i>
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end gap-2 w-100">
            <p-button label="Cancelar" severity="secondary" [outlined]="true"
                      icon="pi pi-times" size="small" (click)="cerrar()" />
            <p-button label="Cambiar contraseña" icon="pi pi-lock" size="small"
                      [loading]="guardando()" (click)="guardar()" />
        </div>
    </ng-template>
</p-dialog>
